import { ContactUsComp } from "../../components/contact_us/contact";

const ContactUs = () =>{

    return(

        <>
            <ContactUsComp />
        </>
    )
}

export default ContactUs